/**
 * Returns the channel info string from a Firestore channel object.
 * Handles both the new `info` field and the legacy `liquidName` + `notes` fields.
 */
export default function getChannelInfo(channel = {}) {
  if (channel.info !== undefined) return channel.info || '';
  return [channel.liquidName, channel.notes].filter(Boolean).join('\n');
}
